import { useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowRight } from "lucide-react";

const BANNER_IMAGE = "https://images.unsplash.com/photo-1649083048337-4aeb6dda80bb?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800";

export default function LifestyleBanner() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);

  return (
    <section ref={ref} data-testid="lifestyle-banner" className="relative flex h-[68vh] min-h-[440px] items-center justify-center overflow-hidden">
      <motion.img
        src={BANNER_IMAGE}
        alt="Everyday Essentials products used naturally in a warm, lived-in home"
        style={{ y: imgY }}
        className="absolute inset-0 h-full w-full scale-110 object-cover"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-black/45" />
      <div className="relative z-10 max-w-3xl px-6 text-center">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="font-serif text-3xl font-medium leading-tight text-white sm:text-4xl lg:text-5xl"
        >
          Small Essentials. <span className="italic">Better Everyday Living.</span>
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.15 }}
          className="mx-auto mt-4 max-w-md text-sm text-white/75 sm:text-base"
        >
          Designed for modern spaces and intentional lifestyles.
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.3 }}
        >
          <Link
            to="/shop"
            data-testid="lifestyle-explore-cta"
            className="group mt-8 inline-flex items-center gap-2 rounded-full bg-white px-7 py-3.5 text-sm font-semibold text-neutral-900 transition-colors duration-300 hover:bg-neutral-200"
          >
            Explore the Collection
            <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </motion.div>
      </div>
    </section>
  );
}
